import NarrativeSmallCard from './container';

export default NarrativeSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/NarrativeSmallCard/index.js